<script lang="ts">
// noinspection JSUnusedGlobalSymbols

import NavigationMode = Datakode.LaravelDatakodeUtils.Enum.NavigationMode

export default {
    name: 'NavigationModeSwitcher',
    components: {},
    props: {
        initialValue: {
            type: String, // NavigationMode
            required: false,
            default: 'displayAll',
        },
    },
    emits: ['changeMode'],
    data() {
        return {
            items: [
                {
                    value: 'displayAll',
                    title: 'Afficher l\'ensemble des éléments',
                },
                {
                    value: 'zoomOnItem',
                    title: 'Zoomer sur l\'élement séléctionné',
                },

            ],
            value: 'displayAll',
        }
    },
    computed: {},
    watch: {
        initialValue(newVal, oldVal) {
            if (newVal !== oldVal && oldVal !== null) {
                this.value = this.initialValue
            }
        },
    },

    mounted() {
        this.value = this.initialValue
        this.emitUpdate(this.value)
    },

    methods: {
        emitUpdate(value: NavigationMode) {
            this.$emit('changeMode', value)
        },
    },

}
</script>

<template>
    <div class="w-33 pl-8">
        <v-select
            v-model="value"
            label="Mode de navigation"
            density="compact"
            variant="outlined"
            hide-details
            :items
            @update:model-value="emitUpdate($event)"
        />
    </div>
</template>
